import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ChatService } from '../../services/chat/chat.service';
import { MessengerService } from '../../services/messenger/messenger.service';
import { SettingsService } from '../../services/settings/settings.service';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss',
})
export class Sidebar {
  private chatService = inject(ChatService)
  private messengerService = inject(MessengerService);
  private settingsService = inject(SettingsService);
  public arena = this.chatService.arena;
  public hasUnreadMessages = this.messengerService.hasUnreadMessages;

  constructor() {
    console.log("This is => ", this.arena());
  }

  openSettings() {
    this.settingsService.activeTab.set('account');
  }
}
